import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import logoUrl from "../../img/logo.png";
import bgDesk from "../../img/bg.jpg";
import bgMob from "../../img/bgmob.jpg";
import { useBrandCtaVars } from "../../hooks/useBrandCtaVars";
import "./login.css";

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function Login({ updateHeader }) {
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [sessionUserData, setSessionUserData] = useState(null);
  const otp = queryParams.get("otp");
  const role = queryParams.get("role");

  const { style: loginCtaVars, themed: loginCtaThemed } = useBrandCtaVars(
    sessionUserData,
    sessionUserData?.companyLogoUrl || logoUrl
  );

  useEffect(() => {
    if (!isLoggedIn) return;
    try {
      setSessionUserData(JSON.parse(sessionStorage.getItem("userData") || "null"));
    } catch {
      setSessionUserData(null);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    const applyBackground = () => {
      const body = document.body;
      const backgroundImage = window.innerWidth <= 768 ? bgMob : bgDesk;
      if (body.classList.contains("common-bg")) {
        body.style.backgroundImage = `url(${backgroundImage})`;
      }
    };
    applyBackground();
    window.addEventListener("resize", applyBackground);
    return () => window.removeEventListener("resize", applyBackground);
  }, []);

  useEffect(() => {
    const existing = sessionStorage.getItem("userData");
    if (existing) {
      sessionStorage.removeItem("userData");
    }
  }, []);

  useEffect(() => {
    const login = async () => {
      if (queryParams.get("save")) {
        setIsLoggedIn(true);
        return;
      }

      const isDemo = queryParams.get("demo") === "true";
      if (isDemo) {
        const id = `demo${Math.floor(Math.random() * 10000)}`;
        const demoUser = {
          userId: id,
          sessionId: `demobypass_${uuidv4()}`,
          organizationId: "demobypass",
          roles: "DEMO",
          gameId: "demogame",
          name: id,
          email: `${id}@gmail.com`,
          token: "",
          source: "DEMO",
          expiry: Date.now() + 24 * 60 * 60 * 1000,
        };
        sessionStorage.setItem("userData", JSON.stringify(demoUser));
        setSessionUserData(demoUser);
        setIsLoggedIn(true);
        return;
      }

      try {
        const apiUrl =
          role === "GUEST_USER"
            ? process.env.REACT_APP_FIREBASE_GUEST_USER_API
            : process.env.REACT_APP_FIREBASE_LOGIN_API;
        const source = role === "GUEST_USER" ? "GUEST_USER" : "ORG_USER";
        const headers = {
          "client-secret": process.env.REACT_APP_CLIENT_SECRET,
          "Content-Type": "application/json",
          "Idempotency-Key": uuidv4(),
        };
        const res = await axios.post(
          apiUrl,
          role === "GUEST_USER" ? { otp, role: "GUEST_USER" } : { otp },
          { headers }
        );
        const data = res?.data?.data;
        if (!data) throw new Error("Invalid login response");

        const userData = {
          userId: source === "GUEST_USER" ? data.id : data.userId,
          sessionId: data.sessionId,
          organizationId: data.organizationId,
          roles: source,
          gameId: data.gameId,
          name: `${data.firstName || ""} ${data.lastName || ""}`.trim() || " ",
          email: data.email || data.employeeId || "",
          expiry: Date.now() + 24 * 60 * 60 * 1000,
          source,
          token: source === "GUEST_USER" ? "" : data.token || "",
        };

        sessionStorage.setItem("userData", JSON.stringify(userData));
        setSessionUserData(userData);
        setIsLoggedIn(true);
      } catch (error) {
        Swal.fire({
          title: "Oops...",
          text: error?.response?.data?.err?.message || "Login failed! Please try again.",
          customClass: { popup: "custom-success-popup" },
        });
      }
    };

    login();
  }, [otp, queryParams, role]);

  useEffect(() => {
    if (!sessionUserData || typeof updateHeader !== "function") return;
    updateHeader({
      imageUrl: sessionUserData.companyLogoUrl || process.env.REACT_APP_EM_LOGO || logoUrl,
    });
  }, [sessionUserData]);

  return (
    <div className="login-main-container" style={{ textAlign: "center" }}>
      <div className="login-main-container1" style={{ textAlign: "center" }}>
        <img src={logoUrl} className="login-logo" alt="" />
      </div>
      {isLoggedIn ? (
        <div style={{ textAlign: "center" }}>
          <Link
            to="/rules"
            className={loginCtaThemed ? "begin-play-btn begin-play-btn--themed" : "begin-play-btn"}
            style={loginCtaThemed ? loginCtaVars : undefined}
          >
            Begin play
          </Link>
        </div>
      ) : null}
    </div>
  );
}

export default Login;